
import Request from '@/models/Request';
import store from '@/store'

export async function getRequestByUuid ({ token, uuid }) {
  const api = await fetch('/api/request', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      uuid
    })
  }).catch(err => console.log(err))

  if (!api.ok) {
    throw new Error('Getting request failed! ')
  }

  const response = await api.json()
  const data = response.data.request
  const request = new Request({ data, ref: data._id })

  if (data.tenant === 'amsterdam') {
    request.municipalityCode = '0363'
  } else {
    request.municipalityCode =
    data.baseData?.geographyCode ||
    data.baseData?.address?.municipality?.code ||
    (!isNaN(Number(data.baseData?.address?.municipality)) && data.baseData?.address?.municipality) || // Sometimes comes as a city name
    data.municipalityCode ||
    data.raw?.MunicipalityCode ||
    data.raw?.Municipality ||
    data.raw?.municipalityCode
  }

  if (request) {
    store.dispatch('requests/setCurrentRequest', { request })
  }

  return request
}
